<button class="btn-content" mat-flat-button="" (click)="openModal()">
  <ng-container *ngIf="!filesLength; else WithFilesTemplate">{{
    "Upload Files" | translate
  }}</ng-container>
  <ng-template #WithFilesTemplate>
    {{ filesLength }} {{ "selected file(s)" | translate }}
  </ng-template>
</button>
